module.exports = __webpack_public_path__ + "static/media/delete-disable.ce6bdf2e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/images/sp/delete-disable.svg
// module id = 388
// module chunks = 0